interface FancyNumber {
    n: number;
}

let a: FancyNumber = {n: null};
const b = a.n.toString(42);

